<template>
  <div v-html="nowTime" class="timer-text">
    <!-- {{ nowTime }} -->
  </div>
</template>

<script>
export default {
    mounted() {
        this.nowTimes()
        setInterval(this.nowTimes,10000);
    },
    data(){
        return {
            nowTime: ''
        }
    },
    methods: {
        timeFormate(timeStamp) {
            this.nowTime = ''
            var week = new Array("日", "一", "二", "三", "四", "五", "六");  
            let year = new Date(timeStamp).getFullYear();
            let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
            let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
            let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
            let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
            let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
            let img = '<img src="static/images/天气.svg" />'
            this.nowTime = img + '&emsp;' +year + "年" + month + "月" + date +"日&emsp;"+" 星期"+week[new Date().getDay()]+'&emsp;'+hh+":"+mm+':'+ss ;
        },
        nowTimes(){
            this.timeFormate(new Date());
        },
        clear(){
            clearInterval(this.nowTimes)
            this.nowTimes = null;
        }
    }
}
</script>

<style scoped>
.timer-text {
    color: white;
    font-size: 20px;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
}
</style>